import * as React from 'react'
import styled from 'styled-components'

export const SoundoutAndFormalRequestVariablesDescription = () => {
  return (
    <Variables>
      <b>利用可能な変数:</b>
      <b>基本情報:</b>
      <VariablesList>
        <dt>[start_at]</dt>
        <dd> 催行日時</dd>
        <dt>[tour_name]</dt>
        <dd> ツアー名</dd>
      </VariablesList>
      <b>ツアー詳細:</b>
      <VariablesList>
        <dt>[tour_short_name]</dt>
        <dd> Short Name</dd>
        <dt>[tour_full_name]</dt>
        <dd> 予約時のツアーの名前（予約サイトに載っているツアー名）</dd>
        <dt>[tour_type]</dt>
        <dd> 依頼するツアー種類（Private Tour or Group Tour）</dd>
        <dt>[tour_date]</dt>
        <dd> ツアー催行日 (YYYY/MM/DD 例: 2025/10/31)</dd>
        <dt>[tour_date_full]</dt>
        <dd> ツアー催行日 (YYYY/MM/DD 例: 2025/10/31 金曜日)</dd>
        <dt>[tour_date_display]</dt>
        <dd> ツアー催行日 （US英語形式 例: 31st Oct)</dd>
        <dt>[tour_date_display_full]</dt>
        <dd> ツアー催行日 （US英語形式 例: 31st Oct 2025 (Sun))</dd>
        <dt>[duration]</dt>
        <dd> ツアー時間（4, 8 等の 4時間, 8時間の数字部分）</dd>
        <dt>[duration_display]</dt>
        <dd> 4 hours, 8 hours 等</dd>
        <dt>[meetup_time]</dt>
        <dd> ツアー集合時間 例: 10:15</dd>
        <dt>[start_time]</dt>
        <dd> ツアー開始時刻 例: 10:30</dd>
        <dt>[end_time]</dt>
        <dd> ツアー終了時刻 （ツアー開始時間 + durationの時刻）</dd>
      </VariablesList>
      <b>場所情報:</b>
      <VariablesList>
        <dt>[meeting_point_name]</dt>
        <dd> 最初に作成されたMeeting Pointの名前（未設定の場合は空欄）</dd>
        <dt>[area]</dt>
        <dd> ツアーの地域 （例: Tokyo, Kyoto）</dd>
        <dt>[meetup_point]</dt>
        <dd> プライベートツアー集合場所のフリーテキスト</dd>
        <dt>[meetup_place_area]</dt>
        <dd> 集合場所のエリア</dd>
        <dt>[meetup_place_sub_area]</dt>
        <dd> 集合場所のサブエリア</dd>
        <dt>[meetup_place_name_ja]</dt>
        <dd> 集合場所名（日本語）</dd>
        <dt>[meetup_place_name_en]</dt>
        <dd> 集合場所名（英語）</dd>
        <dt>[meetup_place_point]</dt>
        <dd> 集合場所の詳細な集合ポイント</dd>
        <dt>[meetup_place_url]</dt>
        <dd> 集合場所情報のURL</dd>
      </VariablesList>
      <b>ガイド情報:</b>
      <VariablesList>
        <dt>[guide_name]</dt>
        <dd> ガイド名（本名）</dd>
        <dt>[guide_nickname]</dt>
        <dd> ガイド名（ニックネーム/ゲストに呼ばせる名前）</dd>
        <dt>[guide_email_address]</dt>
        <dd> ガイドメールアドレス</dd>
        <dt>[guide_fee]</dt>
        <dd> 料金（ガイドランクによって変動。例: ¥10,000）</dd>
      </VariablesList>

      <b>ゲスト情報:</b>
      <VariablesList>
        <dt>[guest_name]</dt>
        <dd> ゲスト名</dd>
        <dt>[guest_num]</dt>
        <dd> ゲスト人数</dd>
        <dt>[guest_info]</dt>
        <dd> ゲスト情報（氏名、人数内訳、その他リクエスト、ピックアップ場所、場所メモ）</dd>
      </VariablesList>

      <b>その他:</b>
      <VariablesList>
        <dt>[agent_name]</dt>
        <dd> 送り主</dd>
        <dt>[ref_number]</dt>
        <dd> 受付番号 （例: 20250301-1100-999-001）</dd>
      </VariablesList>
    </Variables>
  )
}

const Variables = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const VariablesList = styled.dl`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  dt {
    width: 30%;
    font-weight: bold;
  }
  dd {
    width: 70%;
  }
`
